import React from 'react';

import { Loader } from '@components/loader';

import { Container } from './infiniteLoader.styles';

export interface InfiniteLoaderProps {
  isVisible: boolean;
}

export const InfiniteLoader = ({ isVisible }: InfiniteLoaderProps) => (
  <Container isVisible={isVisible}>
    <Loader />
  </Container>
);
